import Patents from "../components/Patents";

export default function PatentsPage() {
  return (
    <section className="py-10">
      <Patents />
    </section>
  );
}
